"use strict";
import { includeIf } from "../../../utils/includeIf";
export const mapTextInputProps = (render) => {
  return (fieldProps) => {
    const {
      input: { type, onChange, ...inputElementProps },
      meta: { error, submitError, data = {} },
      onChange: textInputOnChange,
      ...rest
    } = fieldProps;
    const mappedError = error ?? submitError ?? void 0;
    const mappedProps = {
      error: data.showValidationErrors ? mappedError : void 0,
      ...inputElementProps,
      ...rest,
      ...includeIf(!!type, {
        // We have a conflict between react-final-form and KL. FormTextInput will accept type as a
        // TextInputType but RFF will reinterpret it as a string. Casting it back to TextInputType
        // before rendering the KL input.
        type
      }),
      onChange: (ev) => {
        if (textInputOnChange) {
          textInputOnChange(ev);
        }
        if (onChange) {
          onChange(ev);
        }
      }
    };
    return render(mappedProps);
  };
};
export const mapSegmentedControlProps = (render) => {
  return (fieldProps) => {
    const {
      input: { value, onChange, ...inputElementProps },
      meta: { error, submitError, data = {} },
      onChange: segmentedOnChange,
      ...rest
    } = fieldProps;
    const mappedError = error ?? submitError ?? void 0;
    const mappedProps = {
      error: data.showValidationErrors ? mappedError : void 0,
      ...inputElementProps,
      ...rest,
      value,
      onChange: (ev) => {
        if (segmentedOnChange) {
          segmentedOnChange(ev);
        }
        if (onChange) {
          onChange(ev);
        }
      }
    };
    return render(mappedProps);
  };
};
export const mapSelectProps = (render) => {
  return (fieldProps) => {
    const {
      input: { type, onBlur, onFocus, ...inputElementProps },
      meta: { error, submitError, data = {} },
      ...rest
    } = fieldProps;
    const mappedError = error ?? submitError ?? void 0;
    const mappedProps = {
      error: data.showValidationErrors ? mappedError : void 0,
      ...inputElementProps,
      ...rest
    };
    return render(mappedProps);
  };
};
export const mapCheckboxProps = (fieldProps) => {
  const {
    input: { type, onBlur, onFocus, ...inputElementProps },
    meta: { error, submitError, data = {} },
    ...rest
  } = fieldProps;
  const mappedError = error ?? submitError ?? void 0;
  return data.showValidationErrors ? mappedError : void 0;
};
